module.exports = __webpack_public_path__ + "assets/images/vcr_lighthouse.eb2a71ce3f07ac0451d21dfd2a47f13f.svg";